import {
  IonButton,
  IonButtons,
  IonContent,
  IonDatetime,
  IonDatetimeButton,
  IonGrid,
  IonHeader,
  IonItem,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar,
  IonToast,
  useIonViewWillEnter,
  IonText,
  IonLabel,
} from "@ionic/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
import {
  Box,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  styled,
  Typography,
  Paper,
  Button,
} from "@mui/material";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
// import "../../components/ExploreContainer.css";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useBusinessContext } from "../../context/business-context";

const data = [
  {
    subCompID: "subcomp_id_dbc4c56",
    subName: "Share Capital",
    mcompID_name: "Equity",
    mcompID: "comp_id_9e96e6d",
    ledgerName: "SHARE CAPITAL ACCOUNT",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_9c93cf8",
    subName: "Unearned Revenue",
    mcompID_name: "Current Liabilities",
    mcompID: "comp_id_1b6f747",
    ledgerName: "GENERAL LOAN SUSPENSE ACCOUNT",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_9c93cf8",
    subName: "Unearned Revenue",
    mcompID_name: "Current Liabilities",
    mcompID: "comp_id_1b6f747",
    ledgerName: "LOAN SUSPENSE ACCOUNT",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_9c93cf8",
    subName: "Unearned Revenue",
    mcompID_name: "Current Liabilities",
    mcompID: "comp_id_1b6f747",
    ledgerName: "GENERAL SAVINGS SUSPENSE ACCOUNT",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_9c93cf8",
    subName: "Unearned Revenue",
    mcompID_name: "Current Liabilities",
    mcompID: "comp_id_1b6f747",
    ledgerName: "GENERAL GUARANTOR SUSPENSE LEDGER",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_6de0f83",
    subName: "Short-term Investments",
    mcompID_name: "Current Assets",
    mcompID: "comp_id_b521d1a",
    ledgerName: "HOLDING ACCOUNT",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_ca1c9ac",
    subName: "Accounts Receivable",
    mcompID_name: "Current Assets",
    mcompID: "comp_id_b521d1a",
    ledgerName: "GENERAL GUARANTOR SAVING LEDGER",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_74e4e92",
    subName: "Cash & Cash Equivalents",
    mcompID_name: "Current Assets",
    mcompID: "comp_id_b521d1a",
    ledgerName: "BANK CONTROL LEDGER",
    bal: 0,
  },
  {
    subCompID: "subcomp_id_74e4e92",
    subName: "Cash & Cash Equivalents",
    mcompID_name: "Current Assets",
    mcompID: "comp_id_b521d1a",
    ledgerName: "UNIFIED LEDGER NO (BRANCH WALLET)",
    bal: 0,
  },
];

const FinancialReport = () => {

      const {selectedBusiness } = useBusinessContext()
  
const {
      selectedBusinessId,
      setSelectedBusinessId,
      selectedBusinessTypeId,
      setSelectedBusinessTypeId,
      selectedBusinessName,
      setSelectedBusinessName,
      selectedBusinessTypeName,
      setSelectedBusinessTypeName,
      selectedRoleID,
      setSelectedRoleID,
      selectedRoleName,
    } = useBusinessContext();
  const schema = yup
    .object({
      reportType: yup.string().required("Please select a report type"),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { name } = useParams<{ name: string }>();
  const [reportType, setReportType] = useState("");
  const [posting, setPosting] = useState([]);
  const [report, setReport] = useState([]);
  const [branchID, setBranchID] = useState("");
  const [branchList, setBranchList] = useState([]);

  const [status, setStatus] = useState({ loading: false, error: false });
  const [startDate, setStartDate] = useState(new Date().toISOString());
  const [endDate, setEndDate] = useState(new Date().toISOString());
  const [showToast, setShowToast] = useState(false);
  const [error, setError] = useState("");

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    "& td, & th": {
      border: `1px solid ${theme.palette.grey[400]}`,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  useIonViewWillEnter(() => {
    getLedgerReportList();
    getBranches();
  });

  const getFinancialReport = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);
      formData.append("endDate", endDate);
      formData.append("reportType", reportType);
      const response = await axios.post(
        baseUrl() + "ledgers/financialReport",
        formData,
        config
      );
      console.log({ response });
      console.log(response.data);
      setReport(response.data.data);
      setStatus({ loading: false, error: false });
    } catch (error) {
      setStatus({ loading: false, error: true });
      setError("Failed to load report data.");
      setShowToast(true);
    }
  };

  const getLedgerReportList = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      const response = await axios.post(
        baseUrl() + "ledgers/getMothers",
        formData,
        config
      );
      setPosting(response.data.data);
      setStatus({ loading: false, error: false });
    } catch (error) {
      setStatus({ loading: false, error: true });
      setError("Failed to load report data.");
      setShowToast(true);
    }
  };

  const handleReportTypeChange = (event: SelectChangeEvent) => {
    setReportType(event.target.value);
  };

  const groupBySubName = (data) => {
    if (!data) return {};
    return data.reduce((acc, curr) => {
      if (curr.mcompID_name) {
        if (!acc[curr.mcompID_name]) {
          acc[curr.mcompID_name] = [];
        }
        acc[curr.mcompID_name].push(curr);
      }
      return acc;
    }, {});
  };

  const groupedData = groupBySubName(report);
    const history = useHistory();

  const getBranches = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);

    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getBranchList",
      formData,
      config
    );
    console.log({ response });

    const data = await response.data.data;
    console.log(data);
    setBranchList(data);

    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    // onShowAlert();
    // }
  };
  // Group by mcompID_name
  const groupedData1 = report.reduce((acc, item) => {
    if (!acc[item.mcompID_name]) {
      acc[item.mcompID_name] = {};
    }
    if (!acc[item.mcompID_name][item.subName]) {
      acc[item.mcompID_name][item.subName] = [];
    }
    acc[item.mcompID_name][item.subName].push(item);
    return acc;
  }, {} as Record<string, Record<string, typeof data>>);

  const [runningTotals, setRunningTotals] = useState({
    dr: 0,
    cr: 0,
    balance: 0,
  });

  const calculateRunningTotals = (ledgerEntries) => {
    let drTotal = 0;
    let crTotal = 0;
    let balanceTotal = 0;

    return ledgerEntries.map((ledger) => {
      let dr = ledger.bal > 0 ? ledger.bal : 0; // Example logic for Dr
      let cr = ledger.bal < 0 ? Math.abs(ledger.bal) : 0; // Example logic for Cr
      let balance = dr - cr;

      drTotal += dr;
      crTotal += cr;
      balanceTotal += balance;

      return { ...ledger, dr, cr, balance };
    });
  };

  const finalTotals = { dr: 0, cr: 0, balance: 0 };

  return (
    <IonPage>
 
 <IonHeader style={{ backgroundColor: "white" }}>
              <Box display="flex" justifyContent="space-between" p={2}>
                <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
                {selectedBusinessName && selectedBusinessTypeName && (
                <>
                  {selectedBusinessName} - {selectedBusinessTypeName}
                </>
              )}   
                </Typography>
          
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => history.goBack()}
                  style={{ marginLeft: 10 }}
                >
                  Go Back
                </Button>
              </Box>
            </IonHeader>
  


      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <Box sx={{ padding: "20px", align: "center"   }}>
          <Typography variant="h5" gutterBottom>
            Financial Reports
          </Typography>
          <Divider />

          <Box
  sx={{
    display: "flex",
    gap: "20px", // Add space between each item
    alignItems: "center", // Ensure that the items are vertically aligned in the center
    mt: 3,
    width: "100%",
  }}
>
  <FormControl variant="outlined" sx={{ minWidth: 200 }}>
    <InputLabel>Report Type</InputLabel>
    <Select
      error={!!errors.reportType}
      {...register("reportType")}
      value={reportType}
      onChange={handleReportTypeChange}
      label="Report Type"
    >
      <MenuItem value="">
        <em>Select a report type</em>
      </MenuItem>
      {posting?.map((ledgerType, i) => (
        <MenuItem key={i} value={ledgerType?.motherID}>
          {ledgerType?.name}
        </MenuItem>
      ))}
    </Select>
    <Typography color={"red"} component={"h6"}>
      {errors.reportType?.message}
    </Typography>
  </FormControl>

  <Box sx={{ display: "flex", alignItems: "center" }}>
    <IonLabel>As at</IonLabel>
    <IonDatetimeButton datetime="endDatetime" />
    <IonModal keepContentsMounted={true}>
      <IonDatetime
        id="endDatetime"
        value={endDate}
        onIonChange={(e) => setEndDate(e.detail.value!)}
        presentation="date"
        min="2024-01-01"
        max="2099-12-31"
        showDefaultButtons
      />
    </IonModal>
  </Box>

 

  <IonButton color="secondary" onClick={handleSubmit(getFinancialReport)}>
    Generate Report
  </IonButton>
</Box>

          <Divider sx={{ my: 3 }} />

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>ACCOUNT</strong>
                  </TableCell>
                  <TableCell>
                    <strong>DR</strong>
                  </TableCell>
                  <TableCell>
                    <strong>CR</strong>
                  </TableCell>
                  <TableCell>
                    <strong>BALANCE</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(groupedData1).map(
                  ([mcompID_name, subCategories]) => (
                    <React.Fragment key={mcompID_name}>
                      {/* Major Heading for mcompID_name */}
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                            textTransform: "uppercase",
                          }}
                        >
                          {mcompID_name}
                        </TableCell>
                      </TableRow>
                      {Object.entries(subCategories).map(
                        ([subName, ledgers]) => {
                          let updatedLedgers = calculateRunningTotals(ledgers);

                          let subTotalDr = updatedLedgers.reduce(
                            (sum, ledger) => sum + ledger.dr,
                            0
                          );
                          let subTotalCr = updatedLedgers.reduce(
                            (sum, ledger) => sum + ledger.cr,
                            0
                          );
                          let subTotalBalance = updatedLedgers.reduce(
                            (sum, ledger) => sum + ledger.balance,
                            0
                          );

                          finalTotals.dr += subTotalDr;
                          finalTotals.cr += subTotalCr;
                          finalTotals.balance += subTotalBalance;

                          return (
                            <React.Fragment key={subName}>
                              {/* Sub-Heading for subName */}
                              <TableRow>
                                <TableCell
                                  colSpan={4}
                                  style={{
                                    fontWeight: "bold",
                                    paddingLeft: "20px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {subName}
                                </TableCell>
                              </TableRow>
                              {updatedLedgers.map((ledger, index) => (
                                <TableRow key={index}>
                                  <TableCell style={{ paddingLeft: "40px" }}>
                                    {ledger.ledgerName}
                                  </TableCell>
                                  <TableCell>{ledger.dr.toFixed(2)}</TableCell>
                                  <TableCell>{ledger.cr.toFixed(2)}</TableCell>
                                  <TableCell>
                                    {ledger.balance.toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              ))}
                              {/* Subtotal Row */}
                              <TableRow>
                                <TableCell
                                  style={{
                                    fontWeight: "bold",
                                    paddingLeft: "40px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  SUBTOTAL
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {subTotalDr.toFixed(2)}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {subTotalCr.toFixed(2)}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {subTotalBalance.toFixed(2)}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        }
                      )}
                    </React.Fragment>
                  )
                )}
                {/* Final Total Row */}
                <TableRow>
                  <TableCell
                    style={{ fontWeight: "bold", textTransform: "uppercase" }}
                  >
                    FINAL TOTAL
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {finalTotals.dr.toFixed(2)}
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {finalTotals.cr.toFixed(2)}
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {finalTotals.balance.toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <IonLoading isOpen={status.loading} message="Loading..." />
        <IonToast isOpen={showToast} message={error} duration={5000} />
      </IonContent>
    </IonPage>
  );
};

export default FinancialReport;
